import { ReactNode } from "react";
import { File06 } from "@untitled-ui/icons-react";
import { ReactComponent as FileX } from "#src/assets/images/v2/file-X.svg";
import { ReactComponent as FilePdf } from "#src/assets/images/v2/file-PDF.svg";
import { ReactComponent as FileP } from "#src/assets/images/v2/file-P.svg";

const getSvgFromFileExtension = (ext: string) => {
  // TODO: make these extension suffixes into enum.
  if (["doc", "docx", "odt", "ott", "pages"].includes(ext)) return File06;
  if (["xls", "xlsx", "csv", "ods", "numbers"].includes(ext)) return FileX;
  if (["pdf"].includes(ext)) return FilePdf;
  if (["ppt", "pptx", "odp", "key"].includes(ext)) return FileP;
  return () => null;
};

/**
 * @param fullPath might be the absolute path of the file, so we will need to parse it
 * @param iconSize size of icon in rem
 * @returns
 */
export const getIconFromFileExtension = (
  fullPath: string,
  iconSize: number
): ReactNode => {
  const splittedFullPath = fullPath.split("/");
  const filename = splittedFullPath[splittedFullPath.length - 1];
  const splittedFilename = filename.split(".");
  const ext = splittedFilename[splittedFilename.length - 1];

  const SvgIcon = getSvgFromFileExtension(ext);

  return (
    <SvgIcon
      className="text-gray-v2"
      style={{
        height: iconSize + "rem",
        width: iconSize + "rem",
        minWidth: iconSize + "rem",
      }}
    />
  );
};
